<template>
  <section class="page-container">
    <el-dialog title="子商品明细" :visible.sync="isShow" :close-on-click-modal="false" width="80%">
      <!--工具条-->
      <div ref="toolbar" class="toolbar">
        <el-form :inline="true" :model="filters">
          <!--
          <el-form-item>
            <el-input v-model="filters.name" placeholder="名称"></el-input>
          </el-form-item>
          -->
          <el-form-item>
            <el-button type="primary" @click="list">刷新</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="primary" @click="handleAdd">新增</el-button>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="showImport">导入</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!--列表-->
      <div ref="mainContent" :style="{ height: mainHeight }">
        <el-table
          v-loading="listLoading"
          height="100%"
          :data="results"
          highlight-current-row
          border
          stripe
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="id" label="ID"></el-table-column>
          <el-table-column prop="productId" label="商品ID"></el-table-column>
          <el-table-column prop="userId" label="用户ID"></el-table-column>
          <el-table-column prop="nickname" label="昵称"></el-table-column>
          <el-table-column prop="avatar" label="头像"></el-table-column>
          <el-table-column prop="size" label="尺寸"></el-table-column>
          <el-table-column prop="price" label="价格"></el-table-column>
          <el-table-column prop="time" label="销售时间"></el-table-column>
          <el-table-column prop="createTime" label="创建时间">
            <template slot-scope="scope">{{ scope.row.createTime | formatDate }}</template>
          </el-table-column>
          <!-- <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </div>

      <!-- 分页 -->
      <my-pagination
        ref="pagebar"
        :page="page"
        @current-change="handlePageChange"
        @size-change="handleLimitChange"
      />
    </el-dialog>

    <!--新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
      <el-form ref="addForm" :model="addForm" label-width="120px">
        <el-form-item label="productId">
          <el-input v-model="addForm.productId"></el-input>
        </el-form-item>
        <el-form-item label="userId">
          <el-input v-model="addForm.userId"></el-input>
        </el-form-item>
        <el-form-item label="nickname">
          <el-input v-model="addForm.nickname"></el-input>
        </el-form-item>
        <el-form-item label="avatar">
          <el-input v-model="addForm.avatar"></el-input>
        </el-form-item>
        <el-form-item label="size">
          <el-input v-model="addForm.size"></el-input>
        </el-form-item>
        <el-form-item label="price">
          <el-input v-model="addForm.price"></el-input>
        </el-form-item>
        <el-form-item label="time">
          <el-input v-model="addForm.time"></el-input>
        </el-form-item>
        <el-form-item label="createTime">
          <el-input v-model="addForm.createTime"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="addLoading" @click.native="addSubmit">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
      <el-form ref="editForm" :model="editForm" label-width="120px">
        <el-input v-model="editForm.id" type="hidden"></el-input>
        <el-form-item label="id">
          <el-input v-model="editForm.id"></el-input>
        </el-form-item>
        <el-form-item label="productId">
          <el-input v-model="editForm.productId"></el-input>
        </el-form-item>
        <el-form-item label="userId">
          <el-input v-model="editForm.userId"></el-input>
        </el-form-item>
        <el-form-item label="nickname">
          <el-input v-model="editForm.nickname"></el-input>
        </el-form-item>
        <el-form-item label="avatar">
          <el-input v-model="editForm.avatar"></el-input>
        </el-form-item>
        <el-form-item label="size">
          <el-input v-model="editForm.size"></el-input>
        </el-form-item>
        <el-form-item label="price">
          <el-input v-model="editForm.price"></el-input>
        </el-form-item>
        <el-form-item label="time">
          <el-input v-model="editForm.time"></el-input>
        </el-form-item>
        <el-form-item label="createTime">
          <el-input v-model="editForm.createTime"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="editLoading" @click.native="editSubmit">提交</el-button>
      </div>
    </el-dialog>

    <!-- 导入 -->
    <el-dialog
      title="导入"
      :visible.sync="importFormVisible"
      :close-on-click-modal="false"
      width="420px"
    >
      <el-upload
        ref="import"
        drag
        :action="importActionUrl"
        :auto-upload="false"
        :headers="uploadHeaders"
        :data="{ productId: filters.productId }"
        :on-error="submitImportError"
        :on-success="submitImportSuccess"
        with-credentials
        name="file"
        accept="application/vnd.ms-excel"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div slot="tip" class="el-upload__tip">只能上传xls文件</div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="importFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="importLoading" @click.native="submitImport"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import MyPagination from "@/components/MyPagination";
import { getToken } from "@/utils/auth";
import { getLocale } from "@/utils/locale";
// import mainHeight from "@/utils/mainHeight";
export default {
  name: "ProductSealHistory",
  components: { MyPagination },
  data() {
    return {
      isShow: false,
      productId: 0,
      mainHeight: "600px",
      results: [],
      listLoading: false,
      page: {},
      filters: {},
      selectedRows: [],

      addForm: {},
      addFormVisible: false,
      addLoading: false,

      editForm: {},
      editFormVisible: false,
      editLoading: false,

      importActionUrl:
        process.env.VUE_APP_MALL_API + "/api/admin/product-seal-history/historyImport",
      importFormVisible: false,
      importLoading: false,
    };
  },
  computed: {
    uploadHeaders() {
      const userToken = getToken();
      const locale = getLocale();
      return {
        "X-User-Token": userToken || "",
        "X-User-Locale": locale || "",
      };
    },
  },
  mounted() {
    // mainHeight(this);
    this.list();
  },
  methods: {
    async show(productId) {
      this.isShow = true;
      this.filters.productId = productId;
      await this.list();
    },
    async list() {
      this.listLoading = true;
      const params = Object.assign(this.filters, {
        page: this.page.page,
        limit: this.page.limit,
      });
      try {
        const data = await this.axios.form("mall:/api/admin/product-seal-history/list", params);
        this.results = data.results;
        this.page = data.page;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.listLoading = false;
      }
    },
    handleAdd() {
      this.addForm = {};
      this.addFormVisible = true;
    },
    async addSubmit() {
      this.addLoading = true;
      try {
        await this.axios.post("mall:/api/admin/product-seal-history/create", this.addForm);
        this.$message({ message: "提交成功", type: "success" });
        this.addFormVisible = false;
        await this.list();
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.addLoading = false;
      }
    },
    async handleEdit(index, row) {
      try {
        const data = await this.axios.get("mall:/api/admin/product-seal-history/" + row.id);
        this.editForm = Object.assign({}, data);
        this.editFormVisible = true;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async editSubmit() {
      this.editLoading = true;
      try {
        await this.axios.post("mall:/api/admin/product-seal-history/update", this.editForm);
        await this.list();
        this.editFormVisible = false;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.editLoading = false;
      }
    },
    async handlePageChange(val) {
      this.page.page = val;
      await this.list();
    },
    async handleLimitChange(val) {
      this.page.limit = val;
      await this.list();
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    showImport() {
      this.importFormVisible = true;
    },
    submitImport() {
      if (this.importLoading) {
        return;
      }
      this.importLoading = true;
      try {
        this.$refs.import.submit();
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.importLoading = false;
      }
    },
    submitImportError(err, file, fileList) {
      this.$notify.error({ title: "错误", message: err.message || err });
    },
    async submitImportSuccess(response, file, fileList) {
      this.$notify.success("Import success.");
      await this.list();
      this.importFormVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
